import { render, staticRenderFns } from "./StatusChangeSelect.vue?vue&type=template&id=72396734&scoped=true&"
import script from "./StatusChangeSelect.vue?vue&type=script&lang=ts&"
export * from "./StatusChangeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./StatusChangeSelect.vue?vue&type=style&index=0&id=72396734&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72396734",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VIcon,VRow,VTooltip})
